import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumberOnlyValidation {

  constructor() {}

  static ValidateNumber = () => {
    return (control: AbstractControl) => {
      const rex: RegExp = /^[0-9]*$/;
      if (control.value != null && (!rex.test(control.value) && control.value !== '')) {
        return { validateNumber: true }
      }
      return null;
    }
  }
}